var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportswearAndLifestyle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Footwear-Sneakers--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Footwear Sneakers Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.7 6.67a0.23 0.23 0 0 0 0.21 0 0.25 0.25 0 0 0 0.09 -0.24V4.5a1 1 0 0 0 -1 -1h-2.3a0.25 0.25 0 0 0 -0.2 0.1 0.27 0.27 0 0 0 0 0.23 4.26 4.26 0 0 0 3.2 2.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 3.88a0.51 0.51 0 0 0 -0.49 -0.38H0.5A0.5 0.5 0 0 0 0 4v1.29a1.51 1.51 0 0 0 1 1.42l5.4 1.93a0.5 0.5 0 0 0 0.52 -0.12L8.47 7a0.75 0.75 0 0 1 1.06 1l-1 1a0.25 0.25 0 0 0 -0.07 0.23 0.23 0.23 0 0 0 0.16 0.18l1.08 0.39a0.5 0.5 0 0 0 0.53 -0.12L12 8a0.75 0.75 0 0 1 1 1l-1.18 1.18a0.24 0.24 0 0 0 -0.06 0.23 0.26 0.26 0 0 0 0.16 0.18l1.84 0.66a1.09 1.09 0 0 0 1.27 -0.47A3.5 3.5 0 0 1 18 9.5a3.94 3.94 0 0 1 3 1.44 1 1 0 0 0 0.89 0.56h0.63A1.5 1.5 0 0 0 24 10V8.67a0.5 0.5 0 0 0 -0.42 -0.49 5.78 5.78 0 0 1 -4.66 -4.3Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 1.5A1.5 1.5 0 0 0 22.5 0h-21A1.5 1.5 0 0 0 0 1.5a0.5 0.5 0 0 0 0.5 0.5h23a0.5 0.5 0 0 0 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 17.33a0.23 0.23 0 0 0 -0.21 0.05 0.25 0.25 0 0 0 -0.09 0.19v1.93a1 1 0 0 0 1 1h2.3a0.25 0.25 0 0 0 0.2 -0.1 0.27 0.27 0 0 0 0 -0.23 4.26 4.26 0 0 0 -3.2 -2.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08 20.12a0.51 0.51 0 0 0 0.49 0.38H23.5a0.5 0.5 0 0 0 0.5 -0.5v-1.29a1.51 1.51 0 0 0 -1 -1.42l-5.4 -1.93a0.5 0.5 0 0 0 -0.52 0.12L15.53 17a0.75 0.75 0 0 1 -1.06 -1l1 -1a0.25 0.25 0 0 0 0.07 -0.23 0.23 0.23 0 0 0 -0.16 -0.18l-1.08 -0.39a0.5 0.5 0 0 0 -0.53 0.12L12 16a0.75 0.75 0 0 1 -1 -1l1.18 -1.18a0.24 0.24 0 0 0 0.06 -0.23 0.26 0.26 0 0 0 -0.16 -0.18l-1.84 -0.66a1.09 1.09 0 0 0 -1.27 0.47A3.5 3.5 0 0 1 6 14.5a3.94 3.94 0 0 1 -3 -1.44 1 1 0 0 0 -0.89 -0.56H1.5A1.5 1.5 0 0 0 0 14v1.33a0.5 0.5 0 0 0 0.42 0.49 5.78 5.78 0 0 1 4.66 4.3Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5A1.5 1.5 0 0 0 1.5 24h21a1.5 1.5 0 0 0 1.5 -1.5 0.5 0.5 0 0 0 -0.5 -0.5H0.5a0.5 0.5 0 0 0 -0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportswearAndLifestyle);
export default ForwardRef;